(function () {
	'use strict';
	angular
		.module('jcsfApp')
		.controller(
			'forestServiceProjectsController',
			forestServiceProjectsController
		);

	forestServiceProjectsController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'$filter',
		'$window',
		'events',
		'authService',
	];

	function forestServiceProjectsController(
		$controller,
		$rootScope,
		$scope,
		$filter,
		$window,
		events,
		authService
	) {
		$controller('baseController', { $scope: $scope });
		var vm = this;
		authService.fillAuthData();
		var authentication = authService.authentication;
		vm.projects = [];
		vm.centers = [];
		vm.centerId = 0;
		vm.center = {};

		vm.orderBy =
			sessionStorage.getItem('forestServiceProjectsOrderBy') || 'ProjectName';
		vm.orderByReverse = false;
		vm.setOrderBy = setOrderBy;

		vm.changeCenter = centerChanged;
		vm.centerId = authService.authentication.userInfo.JCCCC;
		vm.resources = {};
		vm.remove = deleteComponent;
		vm.saveForestProjectVerified = saveProjectVerified;
		activate();
		$scope.subscribe(
			events.message._GET_FOREST_SERVICE_PROJECT_LIST_COMPLETE_,
			onGetProjectsComplete
		);
		$scope.subscribe(
			events.message._GET_FOREST_SERVICE_PROJECT_LIST_FAILED_,
			onGetProjectsFailed
		);
		$scope.subscribe(
			events.message._GET_JCCENTER_LIST_COMPLETE_,
			onGetCentersComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_RESOURCES_LIST_COMPLETE_,
			onGetStudentResourcesComplete
		);
		$scope.subscribe(
			events.message._DELETE_PROJECT_FS_COMPLETE_,
			onProjectDeletedFS
		);

		function activate() {
			$scope.publish(events.message._GET_JCCENTER_LIST_, []);
			$scope.publish(events.message._GET_STUDENT_RESOURCES_LIST_, []);
		}
		function onGetProjectsComplete(results) {
			vm.errorMessage = '';
			vm.projects = results;
		}
		function onGetProjectsFailed(results) {
			vm.projects = [];
			if (!results || vm.projects.length === 0) {
				vm.errorMessage = 'No Records Returned';
			}
		}

		function saveProjectVerified(item) {
			if (item.StudentHourProjectId > 0) {
				item.LastModifiedBy = authentication.userName;
			}
			item.ProjectVerified = item.ProjectVerified;

			$scope.publish(events.message._SAVE_FOREST_PROJECT_, [item]);
		}

		function deleteComponent(part) {
			const confirmed = $window.confirm(
				'Are you sure you want to delete ' +
					part.ProjectName +
					', ' +
					part.CalendarYear +
					'?'
			);

			if (confirmed) {
				$scope.publish(events.message._DELETE_PROJECT_FS_, [
					part.StudentHourProjectId,
				]);
			}
		}
		function onProjectDeletedFS(results) {
			vm.changeCenter();
			//$scope.publish(events.message._GET_PROJECT_LIST_, [true, vm.centerId]);
			//vm.center = $filter('filter')(vm.centers, { CenterId: vm.centerId })[0];
		}

		function onGetStudentResourcesComplete(results) {
			vm.resources = results;
		}
		function centerChanged() {
			vm.projects = [];
			if (vm.centerId) {
				$scope.publish(events.message._GET_FOREST_SERVICE_PROJECT_LIST_, [
					vm.centerId,
				]);

				vm.center = $filter('filter')(vm.centers, { CenterId: vm.centerId })[0];
			}
		}

		function onGetCentersComplete(results) {
			vm.centers = results;
			if (vm.centerId !== 29) {
				vm.centerId = vm.centerId;
			} else if (
				$rootScope.$stateParams.id !== null &&
				$rootScope.$stateParams.id !== undefined
			) {
				if (vm.centerId !== 29) {
					vm.centerId = vm.centerId;
				} else {
					vm.centerId = $rootScope.$stateParams.id;
				}
			}
			centerChanged(vm.centerId);
		}

		/**
		 *
		 * @param {string} column
		 */
		function setOrderBy(column) {
			vm.orderByReverse = vm.orderBy === column ? !vm.orderByReverse : false;
			vm.orderBy = column;
			sessionStorage.setItem('forestServiceProjectsOrderBy', column);
		}
	}
})();
